import { Stack, Group } from '@mantine/core';
import { AfaModal, AfaAlert, AfaButton, AfaTextarea } from '../../ui';
import { useState } from 'react';
import { notifications } from '@mantine/notifications';
import ApiService from '../../../utils/ApiService';

interface CancelTramitModalProps {
  apiService: ApiService;
  opened: boolean;
  onClose: (isSubmitting: boolean) => void;
  tramitId: any;
}

export function CancelTramitModal({ apiService, opened, onClose, tramitId }: CancelTramitModalProps) {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [motiu, setMotiu] = useState<string>('');

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    setIsSubmitting(true);
    e.preventDefault();
    const dataForm = {
      state: "Cancel·lat entitat",
      fase: "Cancel·lat entitat",
      cancelledReason: motiu
    };

    apiService.UpdateTramit(tramitId, dataForm)
      .then((result: any) => {
        if (result?.data?.success == true) {
          setIsSubmitting(false);
          onClose(true);
          window.location.reload();
        }
        else {
          setIsSubmitting(false);
          notifications.show({
            title: "Error",
            message: result.message || "S'ha produït un error inesperat.",
            color: "red",
          });
        }
      })
      .catch((error: any) => {
        setIsSubmitting(false);
        notifications.show({
          title: "Error",
          message: error.message || "S'ha produït un error inesperat.",
          color: "red",
        });
      })
  };

  return (
    <AfaModal
      opened={opened}
      onClose={() => { onClose(false) }}
      title="Cancel·lar tràmit"
      size="md"
      centered
    >
      <form onSubmit={handleSubmit}>
        <Stack mt="sm" gap="md">
          <div style={{ width: '100%' }}>
            <AfaAlert type="warning" variant="light" title="Cancel·lar tràmit">
              Si cancel·les aquest tràmit, l'estat canviarà a "Cancel·lat" i no es podrà recuperar. Aquesta acció no es pot desfer.
            </AfaAlert>
          </div>
          <AfaTextarea
            id="motiu-cancelacio"
            name="motiu"
            label="Motiu de la cancel·lació"
            placeholder="Escriure aquí el motiu de la cancel·lació"
            value={motiu}
            onChange={(event) => setMotiu(event.currentTarget.value)}
            autosize
            minRows={3}
            maxRows={6}
            required={true}
          />
          <Group justify="flex-end">
            <AfaButton
              id="btn-cancelar-ara"
              variant="filled"
              color="red"
              type="submit"
              loading={isSubmitting}
            >
              Cancel·lar ara
            </AfaButton>
          </Group>
        </Stack>
      </form>
    </AfaModal>
  );
}
